export const CLUBH_TIERS = ["ICON", "MASTER", "ENTHUSIAST", "Starter"];

export function normalizeLoyaltyTier(tier) {
  if (tier == null) return null;
  const t = String(tier).trim().toLowerCase();
  switch (t) {
    case "icon":
      return "ICON";
    case "master":
      return "MASTER";
    case "enthusiast":
      return "ENTHUSIAST";
    case "starter":
      return "Starter";
    default:
      return null;
  }
}

export function computeClubHTierFromPurchases({
  ytdPurchasesCents = 0,
  previousYearPurchasesCents = 0,
} = {}) {
  const ytd = Number.isFinite(ytdPurchasesCents) ? ytdPurchasesCents : 0;
  const prev =
    Number.isFinite(previousYearPurchasesCents) ? previousYearPurchasesCents : 0;

  const dollars = Math.max(ytd, prev) / 100;

  if (dollars >= 50000) return "ICON";
  if (dollars >= 25000) return "MASTER";
  if (dollars >= 7000) return "ENTHUSIAST";
  return "Starter";
}

export function formatEligibleTiersMessage(eligibleTiers) {
  const tiers = Array.isArray(eligibleTiers) ? eligibleTiers.filter(Boolean) : [];
  if (tiers.length === 0) return null;

  const normalize = (t) => String(t).trim();
  const uniq = Array.from(new Set(tiers.map(normalize)));
  const order = new Map(CLUBH_TIERS.map((t, i) => [t, i]));
  uniq.sort((a, b) => (order.get(a) ?? 999) - (order.get(b) ?? 999));

  if (uniq.length === 1) {
    return `Available exclusively for ${uniq[0]} Members`;
  }
  return `Available exclusively for ${uniq.join(", ")} Members`;
}

